import React, {Component} from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Menu, Segment, Sticky} from 'semantic-ui-react';
import navItems from 'go/components/modules/grantLandingPage/navItems';
import subNavItems from 'go/components/modules/grantLandingPage/navItems/subGrantNavItems';
import {isFemaUser} from 'common/utils';
import {isSubApplicationConfig} from 'go/components/dynamic/modules/grantLandingPage/utils';
import {
  GRANTS_LANDING_PAGE_NAV_ITEMS,
  SUBGRANTS_LANDING_PAGE_NAV_ITEMS,
  GRANTS_LANDING_PAGE_NAV_ITEMS_WITH_AWARDREC,
  SUBGRANTS_LANDING_PAGE_NAV_ITEMS_WITH_SUBGRANT,
} from 'app-ui-componentlibrary/dist/common/constants';
import _ from 'lodash';

export class GrantLandingSideNav extends Component {
  constructor(props) {
    super(props);
  }

  navToSpecificLocation = (location) => {
    this.props.navToSpecificLocation(location);
  };

  generateMenu = (menuItem, index) => {
    let NavItem = navItems[menuItem] || subNavItems[menuItem] || null;
    let classes = 'textSmall';
    let {activeNavItem, getConfig, config, location, grantId, subGrantId} = this.props;
    return (
      <div key={index}>
        {
          <NavItem
            grantId={grantId}
            subGrantId={subGrantId}
            isActive={menuItem === activeNavItem}
            baseClass={classes}
            navToSpecificLocation={this.navToSpecificLocation}
            getConfig={getConfig}
            config={config}
            location={location}
            loadPageWithConfig={(configName) =>
              this.props.updateSelection(menuItem, configName)
            }
          />
        }
      </div>
    );
  };

  render() {
    const {config, context, toggles} = this.props;
    const {configType} = config;
    const activePage =
      isSubApplicationConfig(configType) &&
      _.includes(toggles, 'enableSubgrantSectionOnSGLP')
        ? SUBGRANTS_LANDING_PAGE_NAV_ITEMS_WITH_SUBGRANT
        : isSubApplicationConfig(configType) &&
          isFemaUser(_.get(context, 'auth.permissions'))
        ? SUBGRANTS_LANDING_PAGE_NAV_ITEMS
        : isFemaUser(_.get(context, 'auth.permissions')) &&
          _.includes(toggles, 'awardRecOnGLP')
        ? GRANTS_LANDING_PAGE_NAV_ITEMS_WITH_AWARDREC
        : GRANTS_LANDING_PAGE_NAV_ITEMS;

    return (
      <Segment.Group
        className="sideNavSegment"
        floated="left"
        vertical="true"
        basic="true"
      >
        <Menu className="side-nav-menu" vertical borderless>
          {_.map(activePage, (menuItem, index) => {
            return this.generateMenu(menuItem, index);
          })}
        </Menu>
      </Segment.Group>
    );
  }
}

export default connectDynamic(GrantLandingSideNav);
